export enum CustomerSwitchForbidden {
  title = 'This Page Is Not Currently Available.',
  description = 'We are unable to handle your request for this page. Please refresh your browser and try logging in again.',
}
